export default {
  enums: {
    AdminRoleStatus: {
      NORMAL: 'NORMAL',
      LOCKED: 'LOCKED',
      DISABLED: 'DISABLED',
    },
  },
};
